import Axios from "axios";
import {
    SET_PRODUCTION_RAW_MATERIAL_REQUISITION_RECEIVE_LIST,
    UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST,
} from "@/store/mutation-types";
import { 
    productionRequisitionReceiveResource,
} from "@/store/api";

const state = {
    getRawMetarialRequisitionReceiveList: [],
};

const getters = {
    getRawMetarialRequisitionReceiveList(state) {
        return state.getRawMetarialRequisitionReceiveList;
    },
};

const mutations = {
    [SET_PRODUCTION_RAW_MATERIAL_REQUISITION_RECEIVE_LIST](state, data) {
        state.getRawMetarialRequisitionReceiveList = data;
    },
    [UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST](state) {
        state.getRawMetarialRequisitionReceiveList = [];
    },
};

const actions = {
    saveRawMetarialRequisitionReceive({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(productionRequisitionReceiveResource, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateRawMetarialRequisitionReceive({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${productionRequisitionReceiveResource}/${data.id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getRawMetarialRequisitionReceiveList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(productionRequisitionReceiveResource)
            .then(function (response) {
            commit('SET_PRODUCTION_RAW_MATERIAL_REQUISITION_RECEIVE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_PRODUCTION_RAW_MATERIAL_REQUISITION_LIST');
            reject(error);
            });
        });
    },

    getRawMetarialRequisitionReceiveById({ commit }, data) {
        const getTemplateRecordById = `${productionRequisitionReceiveResource}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getTemplateRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

